import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, map, retry } from 'rxjs/operators';
import { BehaviorSubject, Observable, throwError } from 'rxjs';

import { environment } from 'src/environments/environment.generated';
import { QueryParams } from 'src/app/core/interfaces/common';

@Injectable({
  providedIn: 'root'
})
export class CommonService {
  public _langSelectionEnabled = new BehaviorSubject(true);
  public _consentObject = new BehaviorSubject<any>({});
  public _consents = new BehaviorSubject<any>({});

  constructor(
    private httpClient: HttpClient
  ) { }

  private createAPIHeader() {
    let headerObject: any = {
      'Content-Type': 'application/json',
    };
    return new HttpHeaders(headerObject);
  }

  setConsentObject(object: any) {
    this._consentObject.next(object);
  }

  setConsentsResponse(object: Array<any>) {
    this._consents.next(object);
  }

  getRequestExternal(endpoint: string | undefined, urlExtParams: QueryParams[] = [], queryParams: QueryParams[]): Observable<any> {
    if(urlExtParams.length) {
      urlExtParams.forEach((obj: QueryParams) => {
        endpoint += `/${obj.paramValue}`;
      });
    }

    let params = '';
    if(queryParams.length) {
      params = '?';
      queryParams.forEach((obj: QueryParams) => {
        params += `${obj.paramName}=${obj.paramValue}&`;
      });
      params = params.slice(0, -1);
    }

    const url = environment.apiBaseUrl + endpoint + params;
    const requestHeader = {
      headers: this.createAPIHeader()
    };

    return this.httpClient.get(url, requestHeader).pipe(
      map(resp => {
        return resp;
      }),
      retry(2),
      catchError(this.handleError<any>([]))
    );
  }

  postRequestExternal(endpoint: string | undefined, payload = {}, urlExtParams: QueryParams[] = [], apiCallingForInternalAuth = false): Observable<any> {
    if(urlExtParams.length) {
      urlExtParams.forEach((obj: QueryParams) => {
        endpoint += `/${obj.paramValue}`;
      });
    }
    const apiBaseUrl = apiCallingForInternalAuth ? environment.apiBaseUrl.replace('cmp/', '') : environment.apiBaseUrl;
    const requestUrl = apiBaseUrl + endpoint;

    const requestHeader = {
      headers: this.createAPIHeader()
    };
    return this.httpClient.post(requestUrl, payload, requestHeader).pipe(
      map(res => res),
      catchError((err: any) => {
        this.handleError<any>([]);
        return err;
      })
    );
  }

  patchRequestExternal(endpoint: string | undefined, payload = {}, urlExtParams: QueryParams[] = []): Observable<any> {
    if(urlExtParams.length) {
      urlExtParams.forEach((obj: QueryParams) => {
        endpoint += `/${obj.paramValue}`;
      });
    }
    const url = environment.apiBaseUrl + endpoint;

    const requestHeader = {
      headers: this.createAPIHeader()
    };
    console.log(`PATCH:`);
    console.log(`url: ${url}`);
    console.log(`payload:`);
    console.log(payload);
    console.log(`requestHeader:`);
    console.log(requestHeader);
    return this.httpClient.patch(url, payload, requestHeader).pipe(
      map(res => res),
      catchError(this.handleError<any>([]))
    );
  }

  private handleError<T>(result?: T) {
    return (error: any): Observable<T> => {
      console.error(error);
      console.log(`Failed: ${error.message}`);
      return throwError(() => error);
    }
  }
}
